import React from "react";
import InterestContainer from "./InterestContainer";
import { getCategoryIcon } from "../../helpers/categoryIcons";
import { useTranslation } from "react-i18next";
import colors from "../../constants/colors";

const OptionCard = ({ Icon, text, id, checked, onChange }) => {
    return (
        <div 
            className={`flex flex-col items-center justify-center h-[86px] rounded-[30px] gap-y-[8px] p-4 cursor-pointer transition-all duration-200 w-full ${
                checked 
                    ? 'bg-lightBlue shadow-lightBlue' 
                    : 'bg-transparent border-[1px] border-lightGrey'
            }`}
            onClick={() => onChange(!checked)}
        >
            {Icon && <Icon className={`w-[20px] h-[20px] text-${checked ? 'white' : colors.darkBlue}`} />}
            <label htmlFor={id} className={`text-base cursor-pointer select-none text-${checked ? 'white' : 'darkBlue'}`}>{text}</label>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={() => onChange(!checked)}
                className="hidden"
            />
        </div>
    );
};

const InterestRewards = ({ rewardsCategories, selectedRewardsCategories, onRewardsCategoriesChange}) => {

    const {t, i18n} = useTranslation();

    return (
        <InterestContainer 
            title={t('interests.rewards.title')}
        >
            <div className="grid grid-cols-2 sm:grid-cols-2 gap-[16px] w-full max-w-[800px] overflow-y-auto max-h-[400px] md:max-h-none">
                {rewardsCategories.map((rewardCategory, index) => (
                    <div key={rewardCategory.id} className={index === rewardsCategories.length - 1 ? 'col-span-2' : ''}>
                        <OptionCard
                            id={rewardCategory.id}
                            Icon={getCategoryIcon(rewardCategory.slug)}
                            text={i18n.language === 'pt' ? rewardCategory.name : rewardCategory.name_en}
                            checked={selectedRewardsCategories.includes(rewardCategory.id)}
                            onChange={() => onRewardsCategoriesChange(rewardCategory.id)}
                        />
                    </div>
                ))}
            </div>
        </InterestContainer>
    );
};

export default InterestRewards;